import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Locations', path: '/locations' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-6 lg:px-12 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/592edeeb72878c36421bcef1375eb795/ada717a8cd0c75d288b3cd925c344017.png"
            alt="A&S Cleaning Service Logo"
            className="h-24 w-auto object-contain"
          />
        </Link>

        {/* Desktop Links */}
        <ul className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-3xl font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-emerald-600'
                    : scrolled
                    ? 'text-gray-700 hover:text-emerald-600'
                    : 'text-white hover:text-emerald-300'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:5618461326"
            className={`flex items-center gap-2 text-3xl font-bold transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-emerald-600' : 'text-white hover:text-emerald-300'
            }`}
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-phone-fill text-emerald-500 text-2xl" />
            </div>
            (561) 846-1326
          </a>
          <Link
            to="/contact"
            className="bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Get a Free Quote
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`lg:hidden w-8 h-8 flex flex-col justify-center gap-1.5 cursor-pointer`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`h-0.5 w-6 transition-all ${scrolled ? 'bg-gray-800' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`h-0.5 w-6 transition-all ${scrolled ? 'bg-gray-800' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`h-0.5 w-6 transition-all ${scrolled ? 'bg-gray-800' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white shadow-lg px-6 py-4 flex flex-col gap-3">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-semibold py-2 cursor-pointer ${
                location.pathname === link.path ? 'text-emerald-600' : 'text-gray-700 hover:text-emerald-600'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="tel:5618461326"
            className="flex items-center gap-2 text-sm font-bold text-gray-800 py-2 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-emerald-600 text-base" />
            </div>
            (561) 846-1326
          </a>
          <Link
            to="/contact"
            className="bg-emerald-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center mt-2 cursor-pointer"
          >
            Get a Free Quote
          </Link>
        </div>
      )}
    </header>
  );
}
